"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const title_1 = __importDefault(require("./title"));
const characteristic_items_1 = __importDefault(require("./characteristic-items"));
const MainCharacteristics = (props) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(title_1.default, Object.assign({}, props)),
        react_1.default.createElement("div", { className: "main-characterisctics", "data-cy": (props && props.cyData) || "" },
            react_1.default.createElement(characteristic_items_1.default, Object.assign({}, props)))));
};
exports.default = MainCharacteristics;
//# sourceMappingURL=Characteristics.js.map